import { defineComponent as d, computed as o, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as f, createCommentVNode as n, normalizeStyle as h, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "703ebb8a-0062-4c38-8e16-0f7ef8f3787d" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), v = { mask: "url(#703ebb8a-0062-4c38-8e16-0f7ef8f3787d)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#eee" d="M74.1 115 512 156.9v31.5l-42.4 70.3 42.4 64.2v31.5L74.1 386.8z"></path><path fill="#333" d="M0 0h512v156.8H50z"></path><path fill="#a2001d" d="M150.6 188.3H512v134.5H150.6z"></path><path fill="#496e2d" d="M50 354.3h462V512H0z"></path><path fill="#0052b4" d="M0 0v512l256-256z"></path><path fill="#ffda44" d="m83.4 192.4 31.2 43.6 51.2-16.3-31.9 43.2 31.3 43.6-51-16.9-31.7 43.2.3-53.7L32 262.2 83 246z"></path>', 6), g = { fill: "none" }, x = ["r"], N = /* @__PURE__ */ d({
  __name: "ss",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, l = o(() => 512 + 2 * e.strokeWidth), a = o(() => -e.strokeWidth), c = o(() => 256 + e.strokeWidth / 2);
    return (z, w) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", v, [
        e.flagName ? (s(), i("title", k, f(e.flagName), 1)) : n("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: h({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  N as default
};
//# sourceMappingURL=ss-fc9bb920.js.map
